
import BannerTop from "~/components/home/bannerTop.vue";
import CommonTitle from "~/components/home/commonTitle.vue";
export default {
  name:"case",
  components:{
    CommonTitle,
    BannerTop
  },
  data() {
    return {
      bannerUrl:require("@/static/images/case/banner.png"),
      list:[
        {
          imgUrl:require("@/static/images/case/1.png"),
          title:this.$t('case.cnpc.title'),
          path:"/case/cnpc"
        },
        // {
        //   imgUrl:require("@/static/images/case/2.png"),
        //   title:this.$t('case.klsz.title'),
        //   path:"/case/klsz"
        // },
        {
          imgUrl:require("@/static/images/case/3.png"),
          title:this.$t('case.ningbo.title'),
          path:"/case/ningbo"
        }
      ]
    }
  },
  
}
